import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getInitials = (name?: string) => {
  if (!name?.trim()) return "N/A";

  const words = name.trim().split(/\s+/);

  return words.length === 1
    ? (words[0] ?? "").slice(0, 2).toUpperCase()
    : ((words[0]?.[0] ?? "") + (words[1]?.[0] ?? "")).toUpperCase();
};
